import React from 'react';

const CityTaxIcon: React.FC<{ size?: number; color?: string }> = ({ size = 14, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="2" y="5.5" width="16" height="9" rx="1.5" stroke={color} strokeWidth="1.6" />
    <circle cx="10" cy="10" r="2.2" stroke={color} strokeWidth="1.4" />
    <path d="M4.5 8V8.01M4.5 12V12.01M15.5 8V8.01M15.5 12V12.01" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export default CityTaxIcon;
